import React from "react";
import "./Signup.css";
import PageVisibility from "react-page-visibility";

import { SignupConfirm } from "./SignupConfirm";

import { Seatmap } from "./Seatmap";
import { SeatLegend } from "./SeatLegend";

export class Seater extends React.Component {
  constructor(props) {
    super(props);

    this.showHelp = this.showHelp.bind(this);
    this.goToConfirm = this.goToConfirm.bind(this);
    this.calculatePrice = this.calculatePrice.bind(this);
    this.setSelectedSeats = this.setSelectedSeats.bind(this);
    this.setSelectedSeatObjs = this.setSelectedSeatObjs.bind(this);
    this.goBack = this.goBack.bind(this);

    this.SetTimes = this.SetTimes.bind(this);
    this.PostSeats = this.PostSeats.bind(this);

    this.SetTimer = this.SetTimer.bind(this);
    this.CheckTimer = this.CheckTimer.bind(this);

    this.SetTimeStamp = this.SetTimeStamp.bind(this);
    this.RemoveGUIDSeats = this.RemoveGUIDSeats.bind(this);

    //We use OnLoadPost to get latest stored DB post. Intended to use with cancel button.
    this.state = {
      title: "Plassreservasjon",
      post: "<h2>Plassreservasjon</h2><br>",
      onLoadPost: "<h2>Plassreservasjon<h2><br>",
      showHelp: false,

      setNumPersons: 0,

      totalPrice: 0,

      p1: {},
      p2: {},
      p3: {},
      p4: {},
      p5: {},

      selectedSeats: [],

      selectedSeatObjs: [],

      goToConfirm: false,

      tooYoung: false,

      timeStamp: 0,
      timeToStop: 0,
      timeLeft: 0,
      timeToReturn: 0,

      timeBeforeDelete: 600000,

      visibility: true
    };
  }

  componentWillMount() {
    onbeforeunload = function(e) {
      return "Du vil forlate siden, plassene dine vil åpnes for andre";
    };
    window.onunload = () => {
      this.RemoveGUIDSeats();
    };
  }

  componentDidMount() {
    this.setState({ showHelp: true });

    //this.state.setNumPersons = this.props.setNumPersons;

    this.setState({ setNumPersons: this.props.setNumPersons });

    this.setState({ p1: this.props.p1 });
    this.setState({ p2: this.props.p2 });
    this.setState({ p3: this.props.p3 });
    this.setState({ p4: this.props.p4 });
    this.setState({ p5: this.props.p5 });

    this.interval = setInterval(() => this.CheckTimer(), 1000);

    /*this.state.p1 = this.props.p1;
    this.state.p2 = this.props.p2;
    this.state.p3 = this.props.p3;
    this.state.p4 = this.props.p4;
    this.state.p5 = this.props.p5;
    */
  }

  componentWillUnmount() {
    clearInterval(this.interval);

    onbeforeunload = null;
  }

  //We can stop the fetch of seats if the browser tab is not in focus
  handleVisibilityChange = isVisible => {
    this.setState({ visibility: isVisible });
  };

  showHelp(e) {
    //Trigger App's modal component... Toggles showModal true or false
    if (this.state.showHelp === false) {
      this.setState({ showHelp: true });
    } else {
      this.setState({ showHelp: false });
    }
  }

  calculatePrice() {
    let price = 0;

    if (this.state.setNumPersons >= 1) {
      if (this.state.p1.foodTicket === false) {
        price = price + this.props.priceNoFood;
      } else {
        price = price + this.props.priceWithFood;
      }
    }

    if (this.state.setNumPersons >= 2) {
      if (this.state.p2.foodTicket === false) {
        price = price + this.props.priceNoFood;
      } else {
        price = price + this.props.priceWithFood;
      }
    }

    if (this.state.setNumPersons >= 3) {
      if (this.state.p3.foodTicket === false) {
        price = price + this.props.priceNoFood;
      } else {
        price = price + this.props.priceWithFood;
      }
    }

    if (this.state.setNumPersons >= 4) {
      if (this.state.p4.foodTicket === false) {
        price = price + this.props.priceNoFood;
      } else {
        price = price + this.props.priceWithFood;
      }
    }

    if (this.state.setNumPersons >= 5) {
      if (this.state.p5.foodTicket === false) {
        price = price + this.props.priceNoFood;
      } else {
        price = price + this.props.priceWithFood;
      }
    }

    this.forceUpdate();

    this.setState({ totalPrice: price });
  }

  setSelectedSeats(e) {
    let testArr = [];
    testArr = e;

    this.setState({ selectedSeats: testArr });
  }
  setSelectedSeatObjs(e) {
    let testArr = [];
    testArr = e;

    this.setState({ selectedSeatObjs: testArr });
  }

  goToConfirm() {
    //Button is clicked to go to confirm dialogue

    if (
      (this.state.p1.age < 16 && this.state.p1.age > 0) ||
      (this.state.p2.age < 16 && this.state.p2.age > 0) ||
      (this.state.p3.age < 16 && this.state.p3.age > 0) ||
      (this.state.p4.age < 16 && this.state.p4.age > 0) ||
      (this.state.p5.age < 16 && this.state.p5.age > 0)
    ) {
      this.setState({ tooYoung: true });
    } else {
      this.setState({ tooYoung: false });
    }

    this.calculatePrice();

    if (this.state.goToConfirm === false) {
      this.setState({ goToConfirm: true });
    } else {
      this.setState({ goToConfirm: false });
    }
  }

  goBack() {
    this.SetTimes(0, 0, 0);

    let selectedSeatObjsHolder = this.state.selectedSeatObjs;

    for (let i = 0; i < selectedSeatObjsHolder.length; i++) {
      selectedSeatObjsHolder[i].isReserved = "no";
      selectedSeatObjsHolder[i].timestamp = "none";
    }
    this.setState({ selectedSeatObjs: selectedSeatObjsHolder });

    //this.PostSeats(selectedSeatObjsHolder);
    this.RemoveGUIDSeats();

    this.props.backToForm();
  }

  PostSeats(seats) {
    //Takes an array of seat objects and posts their changes to backend

    fetch("/api/seating/holdseats2/" + this.props.guid, {
      method: "put",
      body: JSON.stringify(seats),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });
  }

  RemoveGUIDSeats() {
    //Takes an array of seat objects and posts their changes to backend

    fetch("/api/seating/removeguidseats/" + this.props.guid, {});
  }

  SetTimes(left, stamp, stop) {
    this.setState({ timeLeft: left });
    this.setState({ timeStamp: stamp });
    this.setState({ timeToStop: stop });
  }
  SetTimeStamp(e) {
    this.setState({ timeStamp: e.target.value });
  }

  SetTimer(setSeat, setObj) {
    //We set the timer
    if (this.state.timeStamp === 0) {
      //If no 0, then another timer is already running
      let date = new Date();
      let time = date.getTime();

      let time_to_ago = time + this.state.timeBeforeDelete; //The amount of time we give the user

      this.setState({ timeStamp: time });
      this.setState({ timeToStop: time_to_ago });

      this.setState({ selectedSeatObjs: setObj });
      this.setState({ selectedSeats: setSeat });
    }
  }

  CheckTimer() {
    if (this.state.timeStamp !== 0) {
      //IF it is 0 then no timeout should be running
      let date = new Date();
      let time = date.getTime();

      if (time > this.state.timeToStop) {
        //When time has run out

        let selectedSeatObjsHolder = this.state.selectedSeatObjs;

        for (let i = 0; i < selectedSeatObjsHolder.length; i++) {
          selectedSeatObjsHolder[i].isReserved = "no";
          selectedSeatObjsHolder[i].reserver = "none";
        }

        this.PostSeats(selectedSeatObjsHolder);

        this.setState({ selectedSeatObjs: [] });
        this.setState({ selectedSeats: [] });

        console.log("time is up");
        this.setState({ timeStamp: 0 });

        this.setState({ timeLeft: 0 });

        setTimeout(this.goBack, 200);
      }

      let counter = time - this.state.timeToStop;

      //We have ms, convert to S
      let seconds = Math.floor(((counter / 1000) % 60) + 1);
      let minutes = Math.floor((counter / 1000 / 60) % 60);

      seconds = seconds.toString();
      seconds = seconds.substring(1);

      minutes = minutes + 1;
      minutes = minutes.toString();
      minutes = minutes.substring(1);

      if (minutes === "") {
        minutes = "0";
      }
      if (seconds === "") {
        seconds = "0";
      }

      if (seconds < 10) {
        seconds = "0" + seconds;
      }

      this.setState({ timeLeft: minutes + ":" + seconds });
    }
  }

  render() {
    /* const legend = (
    <div className="seatContainer">
       <div className = "seatLegend row">
      <div className="btn seatBox btn-success open">1</div>
      <h6> = Åpen plass, kan velges </h6>
      </div>
      <div className = "seatLegend row">
      <div className="btn seatBox taken">1</div>
      <h6> = Reservert plass, kan ikke velges </h6>
      </div>
      <div className = "seatLegend row">
      <div className="btn seatBox held">1</div>
      <h6> = Noen holder av denne plassen, kan bli ledig. </h6>
      </div>
  </div> ); */

    return (
      <div>
        {this.state.goToConfirm === false && (
          <div
            className="Post"
            dangerouslySetInnerHTML={{ __html: this.state.post }}
          />
        )}

        {this.state.goToConfirm === false && (
          <button
            className="btn btno btn-success help helpbutton"
            onClick={this.showHelp}
          >
            Hjelp
          </button>
        )}
        {this.state.showHelp === true && (
          <SeatLegend showHelp={this.showHelp} />
        )}
        <p> </p>

        <PageVisibility onChange={this.handleVisibilityChange}>
          {this.state.goToConfirm === false && (
            <Seatmap
              guid={this.props.guid}
              visibility={this.state.visibility}
              SetTimer={this.SetTimer}
              PostSeats={this.PostSeats}
              SetTimes={this.SetTimes}
              timeLeft={this.state.timeLeft}
              timeStamp={this.state.timeStamp}
              timeToStop={this.state.timeToStop}
              goBack={this.goBack}
              setNumPersons={this.state.setNumPersons}
              p1={this.state.p1}
              p2={this.state.p2}
              p3={this.state.p3}
              p4={this.state.p4}
              p5={this.state.p5}
              goToConfirm={this.goToConfirm}
              setSelectedSeatObjs={this.setSelectedSeatObjs}
              setSelectedSeats={this.setSelectedSeats}
              selectedSeats={this.state.selectedSeats}
            />
          )}
        </PageVisibility>

        {this.state.goToConfirm === true && (
          <SignupConfirm
            guid={this.props.guid}
            goBack={this.goBack}
            SetTimes={this.SetTimes}
            timeLeft={this.state.timeLeft}
            timeStamp={this.state.timeStamp}
            timeToStop={this.state.timeToStop}
            timeToReturn={this.state.timeToReturn}
            goToConfirm={this.goToConfirm}
            totalPrice={this.state.totalPrice}
            tooYoung={this.state.tooYoung}
            selectedSeats={this.state.selectedSeats}
            selectedSeatObjs={this.state.selectedSeatObjs}
            p1={this.state.p1}
            p2={this.state.p2}
            p3={this.state.p3}
            p4={this.state.p4}
            p5={this.state.p5}
            setNumPersons={this.state.setNumPersons}
            foodTicketDisabled={this.props.foodTicketDisabled}
          />
        )}

        <div className="Signup"></div>
      </div>
    );
  }
}

export default Seater;



// WEBPACK FOOTER //
// ./src/Components/Signup/Seater.js